import(/* webpackMode: "eager", webpackExports: ["PrismicToolbar"] */ "/codebuild/output/src3079947011/src/helloero-new/node_modules/@prismicio/react/dist/PrismicToolbar.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3079947011/src/helloero-new/node_modules/next/dist/client/link.js");
